import { useSettings } from './useSettings';

export function useCurrencySymbol() {
  const { data: settings } = useSettings();
  return settings?.currencySymbol ?? '₪';
}
